import React, { useEffect, useState } from "react";
import { Button, Card, Spinner } from "react-bootstrap";
import Axios from "../../axios/axios"; // Adjust the path to your Axios instance

const AdminOrderCancelRequests = () => {
  const [orders, setOrders] = useState([]);
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(null); // store the order id for which action is being taken

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  // Fetch processing orders
  const fetchOrders = async () => {
    try {
      setLoading(true);
      const { data } = await Axios.get("/api/user/processing");
      setOrders(data);
    } catch (error) {
      console.error("Failed to fetch orders", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    if (orders.length > 0 && orders[0].user?._id) {
      getuser();
    }
  }, [orders]);

  // Handle approve or reject
  const handleDecision = async (orderId, action) => {
    try {
      setActionLoading(orderId);

      await Axios.put(`/api/user/handle-cancel/${orderId}`, { action }); // pass action in body
      fetchOrders(); // refresh the list
    } catch (error) {
      console.error("Action failed", error);
    } finally {
      setActionLoading(null);
    }
  };

  const getuser = async () => {
    const userId = orders?.[0]?.user?._id;
    if (!userId) {
      console.warn("User ID is missing, skipping user fetch.");
      return;
    }

    try {
      const res = await Axios.get(`/api/user/${userId}`);
      console.log(res.data, "user data");
      setUserData(res.data);
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  return (
    <div
      className="container mt-4"
      style={{ height: "100vh", display: "flex", flexDirection: "column" }}
    >
      <h3 className="mb-4">Order Cancellation Requests</h3>
      <div style={{ flex: 1, overflowY: "auto" }}>
        {loading ? (
          <Spinner animation="border" />
        ) : orders.length === 0 ? (
          <p>No pending cancellation requests.</p>
        ) : (
          orders.map((order) => (
            <Card key={order._id} className="mb-3 shadow-sm">
              <Card.Body className="d-flex justify-content-between align-items-center">
                <div className="card mb-4 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-primary">Order Details</h5>
                    <p className="card-text">
                      <strong>Order ID:</strong> {order?.orderId || "Unknown"}
                    </p>
                    <p className="card-text">
                      <strong>User:</strong>{" "}
                      {order?.user?.name || "Unknown"}{" "}
                    </p>
                    <p className="card-text">
                      <strong>Phone Number:</strong> {order?.user?.phone},{" "}
                      {order?.user?.phone1 || "Unknown"}
                    </p>
                    <p className="card-text">
                      <strong>Amount:</strong>{" "}
                      <span className="text-success">
                        ₹{order?.orderAmount || 0}
                      </span>
                    </p>
                    <p className="card-text">
                      <strong>Status:</strong>{" "}
                      <span className="badge bg-warning text-dark">
                        Processing
                      </span>
                    </p>
                  </div>
                </div>

                <div className="d-flex flex-column gap-2">
                  <Button
                    variant="danger"
                    disabled={actionLoading === order._id}
                    onClick={() => handleDecision(order._id, "approve")}
                  >
                    {actionLoading === order._id ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Cancel"
                    )}
                  </Button>
                  <Button
                    variant="success"
                    disabled={actionLoading === order._id}
                    onClick={() => handleDecision(order._id, "reject")}
                  >
                    Approve
                  </Button>
                </div>
              </Card.Body>
            </Card>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminOrderCancelRequests;
